import { z } from 'zod';

export interface PublishedItemType {
  id: number;
  name: string;
  icon?: string;
  color?: string;
  itemLevelId: number;
}

export interface PublishedItemLevel {
  id: number;
  level: number;
  name: string;
}

export interface PublishedItemStatus {
  id: number;
  name: string;
  type: string;
  color: string;
}

export interface PublishedTeam {
  id: number;
  name: string;
  color: string;
}

export interface PublishedEstimation {
  id: number;
  label: string;
  estimationSchemeId: number;
}

export interface PublishedEstimationScheme {
  id: number;
  name: string;
  description: string | null;
  isOrganizationDefault: boolean;
  estimations: PublishedEstimation[];
}

export const publishedItemTypeSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  icon: z.string().optional(),
  color: z.string().optional(),
  itemLevelId: z.number().int(),
});

export const publishedItemLevelSchema = z.object({
  id: z.number().int(),
  level: z.number().int(),
  name: z.string(),
});

export const publishedItemStatusSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  type: z.string(),
  color: z.string(),
});

export const publishedTeamSchema = z.object({
  id: z.number(),
  name: z.string(),
  color: z.string(),
});

export const publishedEstimationSchema = z.object({
  id: z.number().int(),
  label: z.string(),
  estimationSchemeId: z.number().int(),
});

export const publishedEstimationSchemeSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  description: z.string().nullable(),
  isOrganizationDefault: z.boolean(),
  estimations: z.array(publishedEstimationSchema),
});
